import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import '../Styles/Tab.css';
class Tab1 extends React.Component{
    render(){
        return(
            <div>
             <Tabs>
               <TabList>
               <Tab>Overview</Tab>
              <Tab>Contact</Tab>
             </TabList>
         <TabPanel>
      <div>
        <h2>Cuisine</h2>
        <p>Bakery, Fast-food</p>
      </div>
      <div>
      <h2>Average Cost</h2>
      <p>&#8377;700 for two people (approx)</p>
      </div>
      </TabPanel>
    <TabPanel>
     <div>
        <h2>Phone Number</h2>
        <p className="phone-number">+9111004725435</p>
      </div>
      <div>
      <h2>The Big Chill Cakery</h2>
      <p>Shop 1, Plot D, Samaruddhi Complex, Chincholi
        ,<br/> Mumbai-400001, Maharashtra</p>
      </div>
    </TabPanel>
  </Tabs>
 </div>
        )
    }
}
export default Tab1;


